import { Ref, ref } from "vue";

export interface Approval {
  companyId: string;
  companyName: string;
  companyNumber: string;
  count: number;
  subName: string;
  subId: string;
}
export default (card: Ref, w?: 400) => {
  const width = ref(w);
  const getWidth = () => card.value?.$el.offsetWidth || 0;
  const onBeforeEnter = () => {
    width.value = getWidth() || w;
  };

  return {
    width,
    onBeforeEnter,
  };
};
